import { ReactNode } from "react";
import PreferredSourceCta from "@/components/preferredSource/PreferredSourceCta";
import { ContentAuthor, Maybe } from "@/graphql/gql/graphql";
import NewsletterWidgetTop from "../newsletter/NewsletterWidgetTop";
import AuthorCommon from "./AuthorCommon";
import styles from "./shareBar.module.scss";

export type ShareBarProps = {
  author: ContentAuthor;
  date: string;
  updatedBy?: Maybe<ContentAuthor>;
  rightSlot: ReactNode;
  hideTopNewsletter: boolean | undefined | null;
};

const ShareBar = ({
  author,
  date,
  updatedBy,
  rightSlot,
  hideTopNewsletter = false,
}: ShareBarProps) => (
  <div className={styles.container}>
    <div className={styles.authorContainer}>
      <AuthorCommon author={author} date={date} updatedBy={updatedBy} />
    </div>
    {!hideTopNewsletter && (
      <>
        <div className={styles.newsletterContainer}>
          <NewsletterWidgetTop />
        </div>
        <div className={styles.preferredSourceContainer}>
          <PreferredSourceCta />
        </div>
      </>
    )}
    <div className={styles.socialContainer}>{rightSlot}</div>
  </div>
);

export default ShareBar;
